/* unplugin-vue-components disabled */import { render } from "./VipAgreement.vue?vue&type=template&id=3b842751&scoped=true"
import script from "./VipAgreement.vue?vue&type=script&lang=js"
export * from "./VipAgreement.vue?vue&type=script&lang=js"

import "./VipAgreement.vue?vue&type=style&index=0&id=3b842751&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b842751"]])

export default __exports__